import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { usePageMeta } from "../hooks/usePageMeta";

export default function LoginPage() {
  usePageMeta("Staff Login");
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      setError(apiError(err.response?.data?.detail, err.message));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-5 py-20">
      <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tighter">
        STAFF <span className="text-primary">LOGIN</span>
      </h1>
      <p className="mt-3 text-sm text-neutral-400">Manage events and upload tournament .TDF files.</p>

      <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
        <div>
          <Label htmlFor="email" className="text-xs uppercase tracking-wider text-neutral-400">Email</Label>
          <Input
            id="email"
            type="email"
            required
            data-testid="login-email-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1.5 bg-white/5 border-white/10 focus:ring-2 focus:ring-primary"
          />
        </div>
        <div>
          <Label htmlFor="password" className="text-xs uppercase tracking-wider text-neutral-400">Password</Label>
          <Input
            id="password"
            type="password"
            required
            data-testid="login-password-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1.5 bg-white/5 border-white/10 focus:ring-2 focus:ring-primary"
          />
        </div>
        {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
        <Button
          type="submit"
          disabled={busy}
          data-testid="login-submit-btn"
          className="w-full bg-primary text-black font-bold uppercase tracking-wider rounded-full hover:bg-[#FFA94D] transition-colors duration-200"
        >
          {busy ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </div>
  );
}
